import React from 'react'
import type { FabProps as MuiFabProps } from '@material-ui/core/Fab'
import MuiFab from '@material-ui/core/Fab'

export type FabProps = MuiFabProps

const Fab = React.forwardRef<HTMLButtonElement, FabProps>(function Fab(props, ref) {
  return <MuiFab ref={ref} {...props} />
})

export default Fab
